import axios from "axios"
import Cookies from "js-cookie"
const baseUrl = window.location.origin

export const client = axios.create({
  baseURL: `${baseUrl}/api`,
  withCredentials: true,
})

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Clear any local user data (Zustand, Context, localStorage, etc.)
      Cookies.remove("sessionToken")
      localStorage.removeItem("user")
      window.location.href = "/" // or use router to push
    }
    return Promise.reject(error)
  }
)
